<ng-template #modalContent let-close="close">
  @if (showMoneyProtectionBanner && moneyProtectionBanner) {
    <div class="modal-money-protection" [class]="moneyProtectionBannerClasses">
      <ng-container *ngComponentOutlet="moneyProtectionBanner"></ng-container>
    </div>
  }
  <div class="modal-content-container">
    <ng-content></ng-content>
  </div>
</ng-template>
